"use client";
import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import { SectionHeading } from "@/components/common/decor";

const testimonials = [
  {
    name: "Mark J. Willis",
    role: "Non-fiction Author",
    text: "I came in with pages of rough notes, and they transformed it into a polished, professional book. The editors were sharp, the structure made sense, and their marketing team positioned it perfectly for my audience.",
    img: "/images/m8.webp",
    featured: true,
  },
  {
    name: "Claire Simmons",
    role: "Memoirist",
    text: "Telling my story was personal and emotional, but the editorial team handled it with such care and respect. The result is a book that's honest, beautifully written, and true to my voice.",
    img: "/images/front-view-girl.webp",
  },
  {
    name: "D.A. Brooks",
    role: "Thriller Author",
    text: "I've worked with editors before, but none as precise and intuitive as this team. They strengthened the plot, tightened the pacing, and helped my thriller go from good to unputdownable.",
  },
  {
    name: "Jared Fields",
    role: "Self-Help Author",
    text: "The publishing support was top-tier. They formatted everything for Kindle, paperback, and even helped me get it into audiobook format. I felt like I had a full team behind me at every stage.",
    img: "/images/m9.webp",
  },
  {
    name: "Lisa H. Chang",
    role: "Business Author",
    text: "From manuscript to audiobook, the process was seamless. The voice actor they matched me with truly understood the tone of my message — it gave my words a whole new dimension.",
  },
  {
    name: "Emma Rodriguez",
    role: "Children's Author",
    text: "The team brought my story to life with magical illustrations and thoughtful editing. My children's book looks and reads better than I ever imagined.",
    featured: true,
  },
];

export default function Testimonials() {
  return (
    <section className="w-full overflow-hidden bg-white py-20">
      <div className="mx-auto max-w-6xl px-4">
        <SectionHeading
          eyebrow="Author Reviews"
          title="What Published Authors Say About Us"
          description="Real reviews from authors whose stalled drafts became celebrated, published books through our hands-on, collaborative process."
          className="mb-14"
        />

        <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 90}
              className={`break-inside-avoid rounded-3xl p-7 ${
                t.featured
                  ? "bg-brand-600 text-white shadow-editorial"
                  : "border border-ink/10 bg-paper text-ink"
              }`}
            >
              <FaQuoteLeft className={`mb-4 text-2xl ${t.featured ? "text-gold-soft" : "text-gold"}`} />
              <blockquote className={`text-[15px] leading-relaxed ${t.featured ? "text-white/90" : "text-ink-soft"}`}>
                {t.text}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                {t.img ? (
                  <img loading="lazy" decoding="async" src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/40" />
                ) : (
                  <span className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-lg font-semibold ${t.featured ? "bg-white/15 text-white" : "bg-brand-50 text-brand-700"}`}>
                    {t.name.charAt(0)}
                  </span>
                )}
                <div>
                  <p className={`font-display font-semibold ${t.featured ? "text-white" : "text-ink"}`}>{t.name}</p>
                  <p className={`text-xs ${t.featured ? "text-white/70" : "text-ink-soft"}`}>{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
